import type { ModuleDefinition } from '../types';

export const tenancyModule: ModuleDefinition = {
  key: 'tenancy',
  milestone: 'M3',
  network: { path: 'tenants', permission: 'tenant.read.network', labelKey: 'tenancy' },
  tenant: { path: 'center', permission: 'tenant.read', labelKey: 'tenancyTenant' },
  load: () => import('./TenancyModule'),
};
